import { useState } from 'react';
import dayjs from 'dayjs';

export const InternalDashboardLogic = () => {
    const [filterDates, setFilterDates] = useState({
        start_date: dayjs().subtract(30, 'days').startOf('day'),
        end_date: dayjs().endOf('day')
    });
    const [summaryLoading, setSummaryLoading] = useState(false);

    const startAndEndUnixDatesParams = () => {
        return `start=${filterDates.start_date.unix()}&end=${filterDates.end_date.unix()}`;
    };

    return {
        filterDates,
        setFilterDates,
        summaryLoading,
        setSummaryLoading,
        startAndEndUnixDatesParams,
    };
};